var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pui-button',_vm._g({staticClass:"pui-thumbnail-main-action pui-thumbnail-main-action__root",attrs:{"variant":"secondary"}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }